<template>
  <div>
    <router-view/>
    <template>
      <div class="text-center">
        <v-snackbar v-model="snackbar" color="success" outlined :timeout="timeout">
          {{ text }}
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="snackbar = false" outlined>
              閉じる
            </v-btn>
            </template>
          </v-snackbar>
        </div>
    </template>
  </div>
</template>
<script>
  export default {
    data: () => ({
      snackbar: false,
      text: 'ログインしました。',
      timeout: 2000,
    }),
    methods: {
      snackbarOpen(){
        const hasVisited = sessionStorage.getItem('hasVisited');
        if (!hasVisited) {
          this.snackbar = true;
          // sessionにて表示した記録を保存
          sessionStorage.setItem('hasVisited', 'true');
        }
      }
    },
    mounted() {
      this.snackbarOpen();
    },
  }
</script>